import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { ArrowLeft, Loader2, Lock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Card, CardContent } from "@/components/ui/card";
import { API, LOGO_URL, setAdminToken } from "./admin-utils";

export function AdminLogin({ onAuthSuccess, onBack }) {
  const [password, setPassword] = useState("");
  const [authLoading, setAuthLoading] = useState(false);
  const [authError, setAuthError] = useState("");

  const verifyPassword = async (e) => {
    e.preventDefault();
    setAuthLoading(true);
    setAuthError("");
    try {
      const res = await axios.post(`${API}/admin/verify`, { password });
      if (res.data.success) {
        setAdminToken(res.data.token);
        onAuthSuccess();
        toast.success("Access granted");
      }
    } catch (error) {
      setAuthError(error.response?.data?.detail || "Invalid password");
    } finally {
      setAuthLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <Card className="w-full max-w-sm">
        <CardContent className="p-6">
          <div className="text-center mb-6">
            <div className="w-20 h-20 mx-auto mb-4 rounded-2xl overflow-hidden bg-[#1aa59a] flex items-center justify-center">
              <img src={LOGO_URL} alt="Munch'd" className="w-full h-full object-contain" />
            </div>
            <h1 className="text-xl font-bold text-gray-800 mb-1">Admin Panel</h1>
            <p className="text-gray-500 text-sm">Enter password to access</p>
          </div>

          <form onSubmit={verifyPassword}>
            <div className="mb-4">
              <div className="relative">
                <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
                <Input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Enter password"
                  className="pl-10"
                  data-testid="admin-password-input"
                />
              </div>
              {authError && <p className="text-red-500 text-sm mt-2">{authError}</p>}
            </div>
            <Button
              type="submit"
              disabled={authLoading || !password}
              className="w-full bg-[#1aa59a] hover:bg-[#158a80]"
              data-testid="admin-login-button"
            >
              {authLoading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Access Admin Panel"}
            </Button>
          </form>

          <Button variant="ghost" onClick={onBack} className="w-full mt-3 text-sm">
            <ArrowLeft className="w-4 h-4 mr-2" />
            Back to Menu
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
